function initialState () {
  return {
    user: {
      uuid: null,
      thumbnail: null,
      gender: null,
      firstname: null,
      lastname: null,
      birth_date: null,
      email: null,
      mobilephone: null,
      street_number: null,
      street_name: null,
      address1: null,
      address2: null,
      zip_code: null,
      town: null,
      country: null,
      stripe_id: null,
      newsletters: {},
      allowed_products: [],
      displayContentConfig: null,
      orders: [],
      emergency_contact: {}
    }
  };
}

function sanitizeInput (data, filteredKeys) {
  return filteredKeys.reduce((obj, key) => ({ ...obj, [key]: data[key] }), {});
}

export default {
  setUser (state, data) {
    state.user = sanitizeInput(data, Object.keys(initialState().user));
  },
  setContacts (state, data) {
    state.contacts = data;
  },
  setLoading (state, data) {
    state.loading = data;
  },
  setSiteInfo (state, data) {
    state.siteInfo = data;
  },
  setActivities (state, data) {
    state.activities = data;
  },
  setActivitiesList (state, data) {
    state.activitiesList = data;
    if (state.selectedActivityKey) {
      state.selected = data[state.selectedActivityKey];
      state.selectedActivity = state.activities.filter(a => a.group === state.selectedActivityKey || a.name === state.selectedActivityKey);
    }
  },
  setSession (state, data) {
    state.session = data;
  },
  setTimeLabel (state, data) {
    state.timeLabel = data;
  },
  setTime (state, data) {
    state.time = data;
  },
  setTimeFrame (state, data) {
    state.timeFrame = data;
  },
  setLoadingContent (state, data) {
    state.loadingContent = data;
  },
  setDisplayContent (state, data) {
    state.displayContentConfig = data;
  },
  setSelected (state, data) {
    state.selected = data;
  },
  addSelected (state, data) {
    if (!state.selected.includes(data)) {
      state.selected.push(data);
    }
  },
  removeSelected (state, data) {
    if (state.selected.includes(data)) {
      state.selected = state.selected.filter(s => s !== data);
    }
  },
  setSelectedActivity (state, data) {
    state.selectedActivity = data;
  },
  setSelectedActivityKey (state, data) {
    state.selectedActivityKey = data;
  },
  addCalendarDay (state, data) {
    if (!state.calendarDays.length) {
      state.calendarDays.push(data);
    } else {
      const calendarDaysIndex = state.calendarDays.findIndex(day => day.uid === data.uid);
      if (calendarDaysIndex !== -1) {
        state.calendarDays[calendarDaysIndex] = data;
      } else {
        state.calendarDays.push(data);
      }
    }
  },
  resetCalendarDays (state) {
    state.calendarDays = [];
  },
  addOpenedParticipant (state, data) {
    state.openedParticipants.push(data);
  },
  removeOpenedParticipant (state, data) {
    const index = state.openedParticipants.findIndex(p => p === data);
    if (index !== -1) {
      state.openedParticipants.splice(index, 1);
    }
  },
  setImpersonateData (state, data) {
    state.impersonateData = data;
  },
  setContremarque (state, data) {
    state.contremarque = data;
  },
  setReload (state, data) {
    state.reload = data;
  },
  setBilletType (state, data) {
    state.billetType = data;
  }
};
